import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import KruozAPI from '../../KruozAPI';

const ContactInfoStep = ({ step, handleInputChange, errors, user, login }) => {
  const [verificationCode, setVerificationCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);
  const [email, setEmail] = useState(step.fields.find(field => field.id === 'Email') && step.fields.find(field => field.id === 'Email').value ? step.fields.find(field => field.id === 'Email').value : (user? user.email : ''));
  const [isVerified, setIsVerified] = useState(((user && user.email == email) || (sessionStorage.getItem('adminPortalUid') != 'siteCustomer'? false: true)));
  // useEffect(() => {
  //   if (isVerified) {
  //     const emailField = step.fields.find(field => field.id === 'Email');
  //     if (emailField) {
  //       handleInputChange('Email', email);
  //     }
  //   }
  // }, [isVerified, email, step.fields, handleInputChange]);

  useEffect(() => {
    if (isVerified && user?.customer) {
      const customerFieldMappings = {
        //'Email': user.customer.email,
        'FirstName': user.customer.firstName,
        'LastName': user.customer.lastName,
        'FullName': user.customer.firstName + ' '+ user.customer.lastName,
        //'Address1': user.customer.address1,
        //'Address2': user.customer.address2,
        'MobileNumber': user.customer.contactNo1,
        'HomeNumber': user.customer.contactNo2,
        'Phone': user.customer.telephoneWork || user.customer.telephoneHome,
        'Mobile': user.customer.mobile,
        'Fax': user.customer.fax,
        "SecondContactEmail": user.customer.secondContactEmail,
        "SecondContactName": user.customer.secondContactName,
        "SecondContactMobile": user.customer.secondContactTelephone,
        "IdentityNumber": user.customer.identityNumber,
        "WorkNumber": user.customer.telephoneWork,
        "HomeNumber": user.customer.telephoneHome,
      };
      step.fields.forEach(field => {
        if (customerFieldMappings[field.id] !== undefined) {
          handleInputChange(field.id, customerFieldMappings[field.id] || '');
        }
      });
    }
  }, [isVerified, user, step.fields, handleInputChange]);

  const handleVerifyCode = async() => {
    setIsLoading(true);
    setError('');
  
    try {
      const encodedEmail = encodeURIComponent(email);
      debugger;
      const verifyResponse = await KruozAPI.get(`/Users/VerifyCode?email=${encodedEmail}&code=${verificationCode}&role=Customer`);
  
      if (verifyResponse.status === 200) {
        const user = verifyResponse.data;

        handleInputChange('customerUserId', user.id);
        const tokenResponse = await KruozAPI.get(`/Users/token?userId=${user.id}&companyId=${user.companyId}`);
        
        if (tokenResponse.status === 200) {
          user.token = tokenResponse.data.token;
          login(user);
          localStorage.setItem('user', JSON.stringify(user));
          setIsVerified(true);
        } else {
          throw new Error('Failed to get token');
        }
      } else {
        throw new Error('Failed to verify code');
      }
    } catch (error) {
      console.error('Error details:', error);
      let errorMessage = 'Failed to verify code. Please try again.';
      if (error.response && error.response.data) {
        errorMessage = typeof error.response.data === 'string' 
          ? error.response.data 
          : JSON.stringify(error.response.data);
      } else if (error.message) {
        errorMessage = error.message;
      }
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendVerificationEmail = async () => {
    setIsLoading(true);
    setError("");
    try {
      const encodedEmail = encodeURIComponent(email);
      const timeZone = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const response = await KruozAPI.post(
        `/Users/SendVerificationCode?email=${encodedEmail}&role=Customer&timeZone=${timeZone}`
      );

      if (response.status === 200) {
        setIsCodeSent(true);
        setResendDisabled(true);
        startResendCountdown();
      } else {
        throw new Error("Failed to send verification code");
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Failed to send verification code. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const startResendCountdown = () => {
    setResendCountdown(60);
    const interval = setInterval(() => {
      setResendCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(interval);
          setResendDisabled(false);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);
  };

  if (!isVerified) {
    return (
      <div className="space-y-6">
        <div>
        {!isCodeSent && <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm mb-5"
            required
          />
          {errors.email && <p className="text-red-500 mt-1">{errors.email}</p>}
        </div>}

        {!isCodeSent ? (
          <button
            onClick={handleSendVerificationEmail}
            className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
            disabled={isLoading}
          >
             {isLoading ? "Sending..." : "Send Verification Code"}
          </button>
        ) : (
          <div className="space-y-4">
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="Enter verification code"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
            <button
              onClick={handleVerifyCode}
              className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Code"}
            </button>
            <button
              onClick={handleSendVerificationEmail}
              className="w-full bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
              disabled={resendDisabled || isLoading}
            >
              {resendDisabled
                ? `Resend Code (${resendCountdown}s)`
                : isLoading
                ? "Sending..."
                : "Resend Verification Code"}
            </button>
          </div>
        )}
      </div>
      {error && (
        <div className="mt-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {typeof error === "string"
            ? error
            : "An error occurred. Please try again."}
        </div>
      )}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {(() => {
        const renderedGroups = new Set();

        const renderField = (field) => {
          const isDisabled = field.enableEditing === false || field.id === 'Email';
          return (
            <div key={field.id}>
              <label htmlFor={field.id} className="block text-sm font-medium text-gray-700">
                {field.label}
              </label>
              {field.dataType === 'TextArea' ? (
                <textarea
                  id={field.id}
                  name={field.id}
                  rows={3}
                  value={field.value || ''}
                  onChange={(e) => handleInputChange(field.id, e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required={field.isRequired}
                  disabled={isDisabled}
                />
              ) : (
                <input
                  type={field.dataType === 'email' ? 'email' : field.dataType === 'tel' ? 'tel' : 'text'}
                  id={field.id}
                  name={field.id}
                  value={field.id === 'Email' ? email : (field.value || '')}
                  onChange={(e) => handleInputChange(field.id, e.target.value)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required={field.isRequired}
                  readOnly={field.id === 'Email'}
                  disabled={isDisabled}
                />
              )}
              {errors[field.id] && (
                <p className="text-red-500 mt-1">{errors[field.id]}</p>
              )}
            </div>
          );
        };

        return step.fields.map((field, idx) => {
          const hasGroup = field.group && String(field.group).trim().length > 0;
          if (hasGroup) {
            if (renderedGroups.has(field.group)) return null;
            renderedGroups.add(field.group);
            const groupFields = step.fields.filter((f) => f.group === field.group);
            return (
              <fieldset
                key={`group-${field.group}-${idx}`}
                className="border border-gray-200 rounded-md p-4"
              >
                <legend className="text-sm font-semibold text-gray-700 px-1">
                  {field.group}
                </legend>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {groupFields.map(renderField)}
                </div>
              </fieldset>
            );
          }
          return renderField(field);
        });
      })()}
    </div>
  );
};

ContactInfoStep.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      dataType: PropTypes.string.isRequired,
      isRequired: PropTypes.bool,
      value: PropTypes.any,
      group: PropTypes.string,
      enableEditing: PropTypes.bool
    }))
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  user: PropTypes.object,
  login: PropTypes.func.isRequired,
};

export default ContactInfoStep;